import { supabase } from "@/integrations/supabase/client";
import {
  Project,
  Blog,
  Experience,
  Education,
  Profile,
  Contact,
  Certificates,
  Recommendation,
  AdditionalExperience,
} from "@/types/supabase";

export const fetchProjects = async (): Promise<Project[]> => {
  const { data, error } = await supabase
    .from("projects")
    .select("*")
    .order("created_at", { ascending: false });

  if (error) {
    console.error("Error fetching projects:", error);
    return [];
  }

  return data as Project[];
};

export const fetchBlogs = async (): Promise<Blog[]> => {
  const { data, error } = await supabase
    .from("blogs")
    .select("*")
    .order("date", { ascending: false });

  if (error) {
    console.error("Error fetching blogs:", error);
    return [];
  }

  return data as Blog[];
};

export const fetchExperiences = async (): Promise<Experience[]> => {
  const { data, error } = await supabase
    .from("experiences")
    .select("*")
    .order("sort_order", { ascending: false })
    .order("created_at", { ascending: false });

  if (error) {
    console.error("Error fetching experiences:", error);
    return [];
  }

  return data as Experience[];
};

export const fetchEducation = async (): Promise<Education[]> => {
  const { data, error } = await supabase
    .from("education")
    .select("*")
    .order("sort_order", { ascending: false })
    .order("created_at", { ascending: false });

  if (error) {
    console.error("Error fetching education:", error);
    return [];
  }

  return data as Education[];
};

export const fetchCertificates = async (): Promise<Certificates[]> => {
  const { data, error } = await supabase
    .from("certificates")
    .select("*")
    .order("sort_order", { ascending: false })
    .order("created_at", { ascending: false });

  if (error) {
    console.error("Error fetching education:", error);
    return [];
  }

  return data as Certificates[];
};

export const fetchProfile = async (): Promise<Profile | null> => {
  const { data, error } = await supabase.from("profile").select("*").single();

  if (error) {
    console.error("Error fetching profile:", error);
    return null;
  }

  return data as Profile;
};

export const fetchContact = async (): Promise<Contact | null> => {
  const { data, error } = await supabase.from("contact").select("*").single();

  if (error) {
    console.error("Error fetching contact:", error);
    return null;
  }

  return data as Contact;
};

export const fetchBlogById = async (id: string): Promise<Blog | null> => {
  const { data, error } = await supabase
    .from("blogs")
    .select("*")
    .eq("id", id)
    .single();

  if (error) {
    console.error("Error fetching blog by ID:", error);
    return null;
  }

  return data as Blog;
};

export const fetchRecommendations = async (): Promise<Recommendation[]> => {
  const { data, error } = await supabase
    .from("recommendations")
    .select("*")
    .order("sort_order", { ascending: false })
    .order("created_at", { ascending: false });

  if (error) {
    console.error("Error fetching recommendations:", error);
    return [];
  }

  return data as Recommendation[];
};

export const fetchAdditionalExperiences = async (): Promise<AdditionalExperience[]> => {
  const { data, error } = await supabase
    .from("additional_experiences")
    .select("*")
    .eq("is_published", true)
    .order("sort_order", { ascending: false })
    .order("created_at", { ascending: false });

  if (error) {
    console.error("Error fetching additional experiences:", error);
    return [];
  }

  return data as AdditionalExperience[];
};
